import React from "react";
import SoftBox from "StyleFeatures/SoftBox";
import SoftTypography from "StyleFeatures/SoftTypography";
import CoverLayout from "Common/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";

function CandidateCheckEmail() {
  return (
    <CoverLayout
      title=""
      description=""
      image={curved9}
    >
      <SoftBox
   sx={{
    maxWidth: "440px",
    mx: "auto",
    textAlign: "center",
    transform: "translateY(-80px)",
  }}
>
  <SoftBox mb={2}>
    <SoftTypography variant="h4" fontWeight="bold" color="success" mb={1}>
      Check Your Email
    </SoftTypography>

    <SoftTypography variant="body2" color="text" sx={{ lineHeight: 1.6 }}>
      We’ve sent a password setup link to your registered email address.
    </SoftTypography>
  </SoftBox>

  <SoftBox
    sx={{
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      border: "1px solid #edf0f2",
      px: 4,
      py: 4,
      mt: 3,
      mb: 3,
    }}
  >
    <SoftTypography variant="h5" fontWeight="bold" mb={1}>
      Registration Successful
    </SoftTypography>

    <SoftTypography variant="body2" color="text" sx={{ lineHeight: 1.7 }}>
      Your account has been created successfully. Please check your inbox and follow the link to set your password.
    </SoftTypography>
  </SoftBox>

  <SoftTypography
    variant="caption"
    color="text"
    display="block"
    sx={{
      lineHeight: 1.6,
      opacity: 0.75,
      maxWidth: "360px",
      mx: "auto",
    }}
  >
    The link will expire in 24 hours. If you don’t see the email, please check
    your spam folder.
  </SoftTypography>
</SoftBox>
    </CoverLayout>
  );
}

export default CandidateCheckEmail;